import image from "./image";
import { SeoRenderer } from "../../../common/helpers/seo";

import loadableComponent from "./loadable";

export default {
    component: loadableComponent,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({
            title: allMessage["article.experience.title"],
            description: allMessage["article.experience.description"],
            allMessage,
            lang,
            image,
        });
    },
};
